import { ISCEService, IController } from 'angular';
import sortBy from 'lodash/sortBy';

import { Controller, Inject } from '@decorators/ngCtrl';

interface PackageInfo {
  name: string;
  url: string;
}

interface LicenseInfo {
  type: string;
  url: string;
}

interface CreditInfo {
  pkg: PackageInfo;
  license: LicenseInfo | null;
}

const LICENSE_INFO = {
  MIT: {
    type: 'MIT',
    url: 'https://mit-license.org/'
  },
  Apache: {
    type: 'Apache 2.0',
    url: 'https://www.apache.org/licenses/LICENSE-2.0'
  },
  BSD: {
    type: 'BSD 3-Clause',
    url: 'https://opensource.org/license/bsd-3-clause'
  },
  CC: {
    type: 'Creative Commons 3.0',
    url: 'https://creativecommons.org/licenses/by/3.0'
  },
  ISC: {
    type: 'ISC',
    url: 'https://opensource.org/license/isc-license-txt'
  },
  FontAwesome: {
    type: 'Font Awesome Custom',
    url: 'https://github.com/FortAwesome/Font-Awesome/blob/master/LICENSE.txt'
  }
} as Record<string, LicenseInfo>;

@Controller
export default class CreditsView implements IController {
  credits: CreditInfo[] = [];

  @Inject readonly $scope!: angular.IScope;
  @Inject readonly $sce!: ISCEService;

  $onInit() {
    void this.loadCredits();
  }

  async loadCredits() {
    const { packages } = await import('@assets/site-packages.json');

    const licenseInfo = { ...LICENSE_INFO };

    for (const [key, info] of Object.entries(licenseInfo)) {
      licenseInfo[key] = {
        type: info.type,
        url: this.$sce.trustAsResourceUrl(info.url)
      };
    }

    this.credits = sortBy(packages, 'name').map((item) => {
      const pkg: PackageInfo = {
        name: item.name,
        url: this.$sce.trustAsResourceUrl(item.url)
      };

      const license = item.license ? licenseInfo[item.license] : null;

      return { pkg, license };
    });

    this.$scope.$apply();
  }
}
